/* eslint-disable */
<template>
    <div>

      <vx-card title="Nome da Empresa" class="mt-4">

        <company-form :tenant-type="tenantType" :companyForm="company" :readonly="!isAuthorized('COMPANY_ADD')"></company-form>

        <vs-row v-if="tenantType === 'ENERGY'">
          <vs-col >
            <vs-table stripe :data="company.profile" class="w-full mt-4" noDataText="Nenhum registro encontrado.">
              <template slot="header">
                <p class="font-bold">Profiles</p>
              </template>
              <template slot="thead">
                <th>Mercado</th>
                <th>Tipo</th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(row, indextr) in data">
                  <td>
                    {{row.market | formatMarket}}
                  </td>
                  <td>
                    {{row.type | formatType}}
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-col>
        </vs-row>

      </vx-card>

      <vx-card title="Balanços" class="mt-4">

        <vs-row class="mt-4">
          <vs-table stripe :data="balanceTable" class="w-full" noDataText="">

            <template slot="thead">

            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <vs-td :key="idx" v-for="(item, idx) in row">
                  <template v-if="idx === 0">
                    <p class="font-semibold">{{item}}</p>
                  </template>
                  <template v-else>
                    <span>{{item | toDecimal}}</span>
                  </template>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </vs-row>

      </vx-card>

      <vx-card title="ScoreCard" class="mt-4">
        <vs-row class="mt-4">
          <vs-table stripe :data="balances" class="w-full">

            <template slot="thead">
              <th>Data</th>
              <th>Auditado</th>
              <th>Rating</th>
              <th></th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <td>
                  {{row.date}}
                </td>
                <td>
                  <span v-if="row.auditedBy">{{row.auditedBy.description}}</span>
                  <span v-else>Não</span>
                </td>
                <td>
                  <vs-button @click="rating(row)" vs-type="line" class="mr-3">Calcular Rating</vs-button>
                </td>
                <td>
                  <vs-button @click="downloadBalance(row.guid)" vs-type="line" class="mr-3">Download</vs-button>
                </td>
              </vs-tr>
            </template>

          </vs-table>
        </vs-row>
      </vx-card>

      <vx-card class="mt-4" v-if="ratingResponse != null">
        <vue-json-pretty
          v-if="ratingResponse.data != null"
          :data="ratingResponse.data"/>
        <vue-json-pretty
          v-if="ratingResponse.message != null"
          :data="ratingResponse.message"/>
      </vx-card>

      <vs-row class="mt-4">
        <vs-button @click="back" vs-type="line" icon="arrow_back" class="mr-3">Voltar</vs-button>
        <vs-button
          v-if="isAuthorized('BALANCE_ADD')"
          @click="showUpload = true"
          vs-type="line"
          icon="save"
          class="mr-3">Cadastrar Balanço</vs-button>
      </vs-row>

      <vx-card class="mt-4" v-show="showUpload">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="9">
            <label class="file-select">
              <!-- We can't use a normal button element here, as it would become the target of the label. -->
              <div class="select-button">
                <!-- Display the filename if a file has been selected. -->
                <span v-if="file">Arquivo selecionado: {{file.name}}</span>
                <span v-else class="vs-component vs-button vs-button-primary vs-button-filled">Selecione um arquivo</span>
              </div>
              <!-- Now, the file input that we hide. -->
              <input type="file" ref="file" @change="handleFileUpload"/>
            </label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="right" vs-w="3">
            <vs-checkbox v-model="overwrite">Sobrescrever</vs-checkbox>
            <vs-button class="ml-1" v-if="file" @click="upload">Cadastrar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>

      <vx-card class="mt-4" title="Propostas - Arquivos" v-if="isAuthorized('BALANCE_FILES_DOWNLOAD')">
        <vs-table class="mt-6" stripe :data="proposes" noDataText="Não há propostas com arquivos anexados">
          <template slot="thead">
            <th>Proposta</th>
            <th>Data da Análise</th>
            <th>Arquivos</th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(propose, indextr) in data">
              <vs-td>
                <a role="button" style="cursor: pointer" @click="viewPropose(propose)">{{propose.codigo}}</a>
              </vs-td>
              <vs-td>
                {{propose.createdAt | formatDate}}
              </vs-td>
              <vs-td>
                <div class="flex justify-end w-full">
                  <vs-button size="small" class="mb-1" style="cursor: pointer" @click="downloadAllFiles(propose.guid)" v-if="propose.files.length > 1" >
                    Baixar Todos
                  </vs-button>
                </div>
                <vs-list>
                  <vs-list-item v-for="(file, indextr) in propose.files" :key="indextr" :title="file">
                    <a style="cursor: pointer" @click="downloadFile(propose.guid, file)">
                      <feather-icon icon="DownloadIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
                    </a>
                  </vs-list-item>
                </vs-list>
              </vs-td>
              <template class="expand-propose" slot="expand">
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import axios from 'axios'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import CompanyForm from "@/components/CompanyForm";
import UserAuthorization from "@/mixins/UserAuthorization";

export default {
  name: 'BalancoEmpresa',
  mixins:[UserAuthorization],
  props: {
    guid: String
  },
  components: {
    VueJsonPretty,
    CompanyForm
  },
  data() {
    return {
      overwrite: false,
      balanceTable: [],
      balances: [],
      company: {
        profile: [],
      },
      sector: {
        code: null,
        name: null
      },
      sectors: [],
      proposes: [
        {
          files: []
        }
      ],
      file: '',
      showUpload: false,
      ratingResponse: null,
      tenantType: null
    }
  },
  beforeMount() {
    this.loadTenantType()
    this.loadSectors()
    this.loadProposes()
    this.load()
  },
  mounted() {
  },
  methods: {
    load() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company/`,
        {
          params: {
            guid: this.guid
          }
        })
        .then((response) => {
          this.company = response.data
          if (this.company != null && this.company.sector != null) {
            this.sector = this.company.sector
          }
        })
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-balance-table/${this.guid}`)
        .then((response) => {
          const balanceObj = Object.entries(response.data.columns)
          this.balanceTable = []

          for (let i = 0; i < balanceObj.length; i++) {
            const line = []
            //Title
            line.push(balanceObj[i][0])
            //Values
            for (let j = 1; j < balanceObj[i].length; j++) {
              const values = balanceObj[i][j]
              for (let z = 0; z < values.length; z++) {
                line.push(values[z])
              }
            }
            this.balanceTable.push(line)
          }

        })

      axios.get(`${process.env.VUE_APP_API}/api/v1/company-balance/${this.guid}`)
        .then((response) => {
          this.balances = response.data
        })

    },
    loadSectors() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/sector/`)
        .then((response) => {
          this.sectors = response.data
        })
    },
    loadProposes() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-balance/${this.guid}/proposes`)
        .then((response) => {
          this.proposes = response.data
        })
    },
    back() {
      this.$router.push({path: '/empresas'})
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    upload() {
      const formData = new FormData()
      formData.append('file', this.file)

      axios.post(`${process.env.VUE_APP_API}/api/v1/balance/${this.company.guid}/${this.overwrite}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {

          this.$vs.notify({
            color: 'success',
            text: 'Balanço cadastrado.'
          })
          this.$router.push({path: `/balanco/${this.guid}`})

        })
        .finally(() => {
          this.file = ''
          this.load()
        })
    },

    rating(row) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/rating`,
        {
          params: {
            company: this.company.guid,
            date: row.date
          }
        })
        .then((response) => {
          this.ratingResponse = response
        })
    },

    viewPropose(propose) {
      this.$router.push({path: `/propose/${propose.guid}`})
    },

    downloadFile(proposeGuid, file) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/file/download`,{
        params: {
          proposeGuid: proposeGuid,
          fileName: file,
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },
    downloadAllFiles(proposeGuid) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/file/download-all/propose`,{
        params: {
          proposeGuid: proposeGuid
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },
    downloadBalance(balanceGuid) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/balance/export`,{
        params: {
          balanceGuid: balanceGuid
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },
    loadTenantType() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant-type`)
        .then((response) => {
          this.tenantType = response.data
        })
    },
    creditReport(cnpj) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/assistant`, {
        params: {
          cnpj: cnpj
        },
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          const contentDisposition = response.headers['content-disposition'];
          const filename = contentDisposition
            ? contentDisposition.split('filename=')[1].replace(/"/g, '')
            : 'analise_credito.html';

          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error('Erro ao baixar o arquivo:', error);
        });
    }
  }
}


</script>

<style scoped>
  /* Don't forget to hide the original file input! */
  .file-select > input[type="file"] {
    display: none;
  }
</style>
